import YourOrders from './your-orders'

export default YourOrders
